export interface Customer {
    fullName: string;                // Full legal name of the customer
    email: string;                   // Primary email address of the customer
    phone: string;                   // Landline or primary contact phone number (non-mobile)
    mobileNumbers: string[];         // List of mobile phone numbers (can include personal and work numbers)
    customerType: CustomerTypeEnum;
    documentType: CustomerDocumentTypeEnum; // Type of identification document (e.g., 'CC', 'CE', 'NIT', 'PPT', 'PASSPORT')
    documentNumber: string;          // Identification document number (e.g., cedula number)
    birthDate: Date;                 // Date of birth of the customer
    referido?: { type: string, data: string };
    serviceData: {
        address: string;                 // General address text (e.g., street and house number)
        department: string;              // Department (state/province of residence (e.g., "Cundinamarca"
        city: string;                    // City or municipality of residence
        neighborhood: string;            // Neighborhood, sector, or locality (e.g., "Chapinero", "La Soledad"
        location: {
            latitude: number;            // Geographic latitude of residence (for maps or geo-positioning
            longitude: number;           // Geographic longitude of residence
        };
        residenceType: ResidenceTypeEnum;    // Type of residence (e.g., "house", "apartment", "rural property"
        residenceNumber: string;         // Number or identifier of the residence (e.g., apartment number, house number
        referencePoint: string;
        installationTime?: 'morning' | 'afternoon' | '';  // Preferred installation time
        installationDate?: string;       // Preferred installation date (YYYY-MM-DD format)

    }

}

const referidosTypes = ['AMIGO', 'FAMILIAR', 'REDES_SOCIALES', 'INSTALADOR o TECNICO', 'OTRO'] as const;

export enum CustomerDocumentTypeEnum {
    CC = "CC", // Cédula de Ciudadanía
    PASAPORTE = "PASAPORTE", // Pasaporte
    NIT = "NIT",// Número de Identificación Tributaria
    CEDULA_DE_EXTRANJERIA = "C.E",// Cédula de Extranjería
    PPT = "PPT",// Permiso por Protección Temporal
}

export enum ResidenceTypeEnum {
    CASA = "CASA",
    APARTAMENTO = "APARTAMENTO",
    RURAL = "RURAL",
    OTRO = "OTRO",
}

export enum CustomerTypeEnum {
    NATURAL = "NATURAL",
    JURIDICO = "JURIDICO",
}

export enum CustomerStateEnum {
    PROSPECTO = "PROSPECTO",
    CLIENTE = "CLIENTE",
}
